module.exports = __webpack_public_path__ + "img/img19.77ea65a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/03/img19.png
// module id = 226
// module chunks = 0